import getIdReduxUtil from 'modules/redux/utils/get-id'
import { getDeepByIdDaySelector } from 'modules/day/redux/selectors/getDeepById/index.js'
import { getDayPointersByIdPlanSelector } from 'modules/plan/redux/selectors/getDayPointersById/index.js'

export const getDaysDeepByIdPlanSelector = planId => state => {
  const dayPointers = getDayPointersByIdPlanSelector(planId)(state)
  return dayPointers.map((dayPointer) => {
    const dayId = getIdReduxUtil(dayPointer)
    return getDeepByIdDaySelector(dayId)(state)
  })
}
